import React from "react";
import { useTranslation } from "react-i18next";
import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterEnumValue from "../enumCheckBox/IDataFilterEnumValue";
import IDataFilterProps from "../IDataFilterProps";
import RadioInput from "../../radioInput/RadioInput";
import IRadioInputData from "../../radioInput/IRadioInputData";
import { getTranslatedFormText } from "features/shared/helpers/translationHelper";

const DataFilterEnumRadioBox = (props: IDataFilterProps) => {
  // translation
  const { t } = useTranslation([
    props.filterDescriptor.valueTranslationPath || "",
  ]);
  const tLables = useTranslation("shared\\dataFilters").t;

  const handleOnChangeRadioBoxForEnum = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const enumChecked: boolean = e.target.checked;
    const enumKey: string = e.target.value;
    const enumName: string = e.target.name;

    let newDescriptors = [...props.descriptors];

    // Získám descriptor
    const descriptor = newDescriptors.find((x) => x.name === enumName);
    if (!descriptor) return;

    // Původní hodnotu nastavím na false
    resetOldValue(descriptor);

    // Získám aktuální hodnotu z descriptoru
    const value = (descriptor.value as IDataFilterEnumValue[]).find(
      (x) => x.key === enumKey
    );

    // Nastavím hodnotu
    if (value) {
      value.value = enumChecked;
    } else {
      // Pokud nenajdu, vytvořím novou
      (descriptor.value as IDataFilterEnumValue[]).push({
        key: enumKey,
        value: enumChecked,
      });
    }

    // Update
    props.setDescriptors(newDescriptors);
  };

  const getRadioOptions = (): IRadioInputData[] => {
    const radioInputData: IRadioInputData[] = [];

    (props.filterDescriptor.value as IDataFilterEnumValue[]).forEach(
      (enumValue) => {
        if (!enumValue.hidden) {
          radioInputData.push({
            value: enumValue.key,
            label: t(enumValue.key),
          });
        }
      }
    );

    return radioInputData;
  };

  const getSelectedValue = (): string => {
    return (
      (props.filterDescriptor.value as IDataFilterEnumValue[]).find(
        (x) => x.value
      )?.key ?? ""
    );
  };

  const resetOldValue = (descriptor: IDataFilterDescriptor) => {
    const oldValue = (descriptor.value as IDataFilterEnumValue[]).find(
      (x) => x.value
    );
    if (oldValue) oldValue.value = false;
  };

  return (
    <RadioInput
      key={props.reactKey}
      name={props.filterDescriptor.name}
      label={getTranslatedFormText(props.filterDescriptor, "label", tLables)}
      data={getRadioOptions()}
      selectedValue={getSelectedValue()}
      onChange={handleOnChangeRadioBoxForEnum}
    />
  );
};

export default DataFilterEnumRadioBox;
